// @ts-nocheck
/*
  传入参数：路由表和目标路由
  返回：当前路由下的按钮
  根据返回的按钮数组中是否含有来判断按钮是否显示 arr.includes('XXX')
*/
var PermissionList = /** @class */ (function () {
    function PermissionList(routerList, routerChain) {
        this.result = {};
        this.routerList = routerList;
        this.routerChain = routerChain;
    }
    PermissionList.prototype.getList = function () {
        this.recursion(this.routerList);
        // console.log(Object.keys(this.result))
        if (Object.keys(this.result).length !== 0) {
            return this.result.children.map(function (item) {
                return item.title;
            });
        }
        return [];
    };
    PermissionList.prototype.recursion = function (list) {
        var _this = this;
        list.forEach(function (item) {
            if (item.path === _this.routerChain) {
                _this.result = item;
            }
            else {
                _this.recursion(item.children);
            }
        });
    };
    return PermissionList;
}());
export default PermissionList;
